import { Injectable } from '@angular/core';
import { Events } from 'src/providers/events/events';
import { Util } from 'src/shared/util/util';

@Injectable()
export class Localstorage {

  constructor(
    private util: Util,
    private events: Events,
  ) {}

  getSingleData(type) {
    return localStorage.getItem(type);
  }

  getMultipleData(type) {
    const item = localStorage.getItem(type);
    return item ? JSON.parse(item) : null;
  }

  setSingleData(name, data) {
    try {
      localStorage.setItem(name, data);
    } catch (e) {
      if (this.isQuotaExceeded(e)) {
        this.handleQuotaExceededError();
      } else {
        throw e;
      }
    }
  }

  setMultipleData(name, object) {
    try {
      localStorage.setItem(name, JSON.stringify(object));
    } catch (e) {
      if (this.isQuotaExceeded(e)) {
        this.handleQuotaExceededError();
      } else {
        throw e;
      }
    }
  }

  private isQuotaExceeded(e) {
    return e instanceof DOMException && (
      e.code === 22 || e.code === 1014 ||
      e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED'
    );
  }

  private async handleQuotaExceededError() {
    await this.util.showAlert(
      'Storage Full',
      'Your device storage is full. Please free up some space to continue using the app.',
      false,
      [{
        text: 'Logout',
        handler: () => {
          this.events.publish('logout');
        }
      }]
    );
  }
}
